import { useDepositsList } from 'modules/pools/hooks/useDepositsList'

import { PageLoader } from 'shared/ui/layout/PageLoader'
import { DashboardRowDeposit } from 'modules/pools/ui/DashboardRowDeposit'
import { DashboardEmptyCTA } from 'modules/pools/ui/DashboardEmptyCTA'

import { createRoute } from 'modules/router/utils/createRoute'
import * as links from 'modules/router/links'

function RouteDashboardDeposits() {
  const deposits = useDepositsList()

  if (deposits.isLoading || deposits.isValidating) {
    return <PageLoader />
  }

  if (!deposits.data?.length) {
    return (
      <DashboardEmptyCTA
        link={links.deposit}
        fashion="purple"
        timeText="You don’t have"
        entityName="deposits"
        actionText="Deposit"
        testId="dashboard-deposit-empty-cta"
      />
    )
  }

  return (
    <>
      {deposits.data.map((item, i) => (
        <DashboardRowDeposit
          key={i}
          apy={item.apy}
          poolAddress={item.poolAddress}
          depositedAsset={item.depositedAsset}
          depositedAmount={item.depositedAmount}
          accruedInterest={item.accruedInterest}
          risk={item.risk}
        />
      ))}
    </>
  )
}

export const routeDashboardDeposits = createRoute({
  component: RouteDashboardDeposits,
  checkConnect: true,
})
